<template>
    <div class="state-abstract">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'StateAbstract'
}
</script>

<style scoped>
.state-abstract {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    color: rgb(var(--v-theme-secondary));
    font-size: 1.4rem;
    text-align: center;
}

@media (max-width: 600px) {
    .state-abstract {
        padding-bottom: 100px;
    }
}
</style>